import React, { ComponentType } from 'react';
import { Skeleton } from '@mui/material';

interface Props {}

export const SlidePaneSkeleton: ComponentType<Props> = () => {
  return (
    <>
      <div className={'p-[0px] relative z-10 bg-[#fff]'}>
        <div className={''}>
          <Skeleton
            variant="rectangular"
            sx={{ marginBottom: '2px' }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="rectangular"
            sx={{ marginBottom: '2px' }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="rectangular"
            sx={{ marginBottom: '2px' }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="rectangular"
            sx={{ marginBottom: '2px' }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="rectangular"
            sx={{ marginBottom: '2px', opacity: 0.8 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="rectangular"
            sx={{ marginBottom: '2px', opacity: 0.6 }}
            animation={'wave'}
            height={40}
          />
          <Skeleton
            variant="rectangular"
            sx={{ marginBottom: '2px', opacity: 0.4 }}
            animation={'wave'}
            height={40}
          />
        </div>
      </div>
    </>
  );
};
